import {normalizeString} from "./coding.utils";

/* Specify -1 for unrestricted decimals, otherwise provide a number to round off to those particular decimal places */
export const STORE_VALUE_DECIMALS_KEY = normalizeString("store_value_decimals")